<template>
  <div
    class="
      fixed
      left-0
      top-0
      z-40
      h-screen
      w-screen
      bg-black-main/50
      will-change-auto
    "
  />
</template>
